import React from "react";
import ReactDOM from "react-dom/client";
// Self-hosted pixel fonts. Each @fontsource package bundles a single
// @font-face declaration pointing at a hashed .woff2 emitted into
// `assets/` by Vite — same-origin, so the SPA's strict CSP allows it
// and we drop the third-party request to fonts.googleapis.com.
import "@fontsource/press-start-2p";
import "@fontsource/vt323";
import { App } from "./App";
import { buildRootCss } from "./theme/endesga32";
import { installBattleAnimations } from "./theme/battleAnimations.css";
import { ensureCsrfToken } from "./api/client";

// Inject the Endesga-32 palette + semantic CSS variables on `:root`
// before React mounts. Anything that can't read the pixelTheme JS
// object — the <body> background, native scrollbars — picks up its
// color through `var(--ui-*)` instead of hard-coding hex.
const styleEl = document.createElement("style");
styleEl.setAttribute("data-source", "endesga-32");
styleEl.textContent = buildRootCss();
document.head.appendChild(styleEl);

// Disable the browser's native image-drag affordance everywhere — it
// otherwise hijacks our hand-to-board / block-line drag gestures.
const dragGuardEl = document.createElement("style");
dragGuardEl.setAttribute("data-source", "image-drag-guard");
dragGuardEl.textContent = `
img { -webkit-user-drag: none; user-drag: none; user-select: none; -webkit-user-select: none; }
`;
document.head.appendChild(dragGuardEl);

// Safari is hit-or-miss on the CSS rule above and any dragstart that
// escapes still fires the browser's ghost-image. Cancel <img> dragstart
// at capture so no component-level handler has to remember the prop.
window.addEventListener(
  "dragstart",
  (ev) => {
    const t = ev.target;
    if (t instanceof HTMLImageElement) ev.preventDefault();
  },
  true,
);

installBattleAnimations();

// Best-effort CSRF bootstrap. The token is needed for the first
// state-changing request (e.g. login); subsequent responses refresh
// it. If the network call fails we still render — pages that don't
// POST work fine, and the user gets a clear error when they try a
// POST without a token.
void ensureCsrfToken().catch(() => undefined);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
